export class CoxContactSearchError extends Error {
  constructor(message: string, public phoneNumber: string) {
    super(message);
  }
}
